import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import { alpha, styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Data } from './datatable-state';

const PREFIX = 'DataTable';

const classes = {
  propertiesContent: `${PREFIX}-propertiesContent`
};

const Root = styled('div')(() => ({
  [`&.${classes.propertiesContent}`]: {
    maxWidth: '100%',
    paddingTop: '0px',
    overflow: 'auto',
    '& tfoot > tr > td': {
      borderBottom: '0px'
    },
    '&::-webkit-scrollbar': {
      width: '7px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: '3px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555'
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '3px'
    },
    scrollbarColor: '#888 #f1f1f1',
    scrollbarWidth: 'thin'
  }
}));

interface DataTableProps {
  data?: Data[];
  columns: any[];
  title?: string;
}

const DataTable = ({ data, columns, title }: DataTableProps) => {
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [page, setPage] = React.useState(0);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Root className={classes.propertiesContent} data-testid="datatable">
      <Typography variant="h6">{title || ''}</Typography>
      <TableContainer component={Paper} sx={{ boxShadow: 'none', backgroundColor: 'transparent' }}>
        <Table size="small" aria-label="simple table">
          <TableHead>
            <TableRow>
              {columns.map((column: any, index: number) => (
                <TableCell key={index} sx={{ backgroundColor: alpha('#fafafa', 0.2) }}>
                  <Typography sx={{ fontWeight: 600 }} variant="caption">
                    {column.title}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row: any, index: number) => (
                <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row" sx={{ borderBottomWidth: '0px' }}>
                    <Typography variant="caption">{row.role}</Typography>
                  </TableCell>
                  <TableCell sx={{ borderBottomWidth: '0px' }}>
                    <Typography variant="caption">{row.tasks}</Typography>
                  </TableCell>
                  <TableCell sx={{ borderBottomWidth: '0px' }}>
                    <Typography variant="caption">
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        href={row.informationitems?.link || ''}
                        underline="none"
                      >
                        {row.informationitems?.name}
                      </Link>
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data?.length || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Root>
  );
};

export default DataTable;
